import React, { useRef } from "react"
import { useLocale } from "src/common/hooks"
import { MARKS, BLOCKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import moment from "moment"
import "moment/locale/ru"

import { Indent } from "../../../../uikit"

import * as S from "./styled"

const options = {
  renderNode: {
    // eslint-disable-next-line react/display-name
    [BLOCKS.PARAGRAPH]: (node, children) => children,
    [INLINES.HYPERLINK]: (node, children) => children,
  },
  renderMark: {
    [MARKS.BOLD]: text => text,
  },
}

const Post = ({
  title,
  blogPostId,
  bpAuthor,
  bpIntroduction,
  createdAt,
  heroImage,
  readLength,
}) => {
  const locale = useLocale()
  const pEl = useRef(null)

  moment.locale(locale)

  // Generate URL based on the new pattern
  const postUrl = locale.includes("ru") 
    ? `/ru-ru/blog/${blogPostId.toLowerCase()}`
    : `/blog/${blogPostId.toLowerCase()}`

  return (
    <S.Container to={postUrl}>
      {heroImage && (
        <S.Thumbnail
          src={heroImage?.fixed?.src}
          srcset={heroImage?.fixed?.srcSet}
        />
      )}
      <S.InfoBox>
        <S.DetailsBox>
          <S.Details>
            <time dateTime={createdAt}>
              {moment(createdAt).format(
                locale === "en-US" ? "MMMM DD, YYYY" : "D MMMM YYYY"
              )}
            </time>{" "}
          </S.Details>
          <S.Details>{readLength}</S.Details>
        </S.DetailsBox>

        <Indent lg={8} md={8} sm={8} />
        <S.TextBox $hasCover={!!heroImage} ref={pEl}>
          <S.Title>{title}</S.Title>
          <Indent lg={8} md={8} sm={8} />
          <S.Introduction>
            {bpIntroduction?.json
              ? documentToReactComponents(bpIntroduction?.json, options)
              : bpIntroduction}
          </S.Introduction>
        </S.TextBox>
        <Indent lg={16} md={16} sm={16} />
        <S.AuthorName>{bpAuthor}</S.AuthorName>
      </S.InfoBox>
    </S.Container>
  )
}

export default Post
